import { Currencies } from '../constants/Currencies';

const currencyMap = new Map(Object.entries(Currencies));

const decimalSeparator = (1.1).toLocaleString().charAt(1) ?? '.';

/** `value` should be 100x actual value to account for fractional precision issues */
export default function formatCurrency(value: number, currencyCode = 'USD') {
  let currencyConfig = currencyMap.get(currencyCode) || Currencies.USD;
  let { currencySymbol, fractionDigits } = currencyConfig;
  let amount = Math.round(value ?? 0);
  let formattedAmount = localeFormat(Math.abs(amount / 100), fractionDigits);
  // The following logic for placement of currency symbol and negative sign is
  // not perfect. In a correct implementation the placement can vary by the
  // locale of the viewer as well as the currency being displayed. See
  // https://docs.microsoft.com/en-us/globalization/locale/currency-formatting
  let signPrefix = amount < 0 ? '-' : '';
  if (currencySymbol.length > 1) {
    // For some currencies we'll put the label before the negative sign, e.g. "IDR -200"
    return currencySymbol + signPrefix + formattedAmount;
  } else {
    // For other currencies we'll put the negative sign first, e.g. "-$200.00"
    return signPrefix + currencySymbol + formattedAmount;
  }
}

function localeFormat(value: number, fractionDigits: number) {
  // Grab the decimal part by using toFixed with the fractionDigits provided
  let decimalPart = value.toFixed(fractionDigits).split('.')[1] ?? '';
  // Format the whole number part using locale-specific thousands separator
  let wholePart = (value | 0).toLocaleString();
  return decimalPart ? wholePart + decimalSeparator + decimalPart : wholePart;
}
